// extracted by mini-css-extract-plugin
module.exports = {"customSlideOptionsContainer":"CampaignFromTemplateCreatePage_customSlideOptionsContainer__1Xgzl"};